import HexagonHovered from "../images/home/hexagons/HexagonHovered.svg";
import Hexagon from "../images/home/hexagons/HexagonStandard.svg";
import { CGI_GRADIENT_A_45DEG, CGI_WHITE } from "../helpers/enums";
import { Box, Typography } from "@mui/material";

export default function ClickableCategoryHexagon({
  category,
  selectedPreferences,
  setSelectedPreferences,
}) {
  return (
    <Box
      onClick={() => {
        if (!selectedPreferences.includes(category)) {
          setSelectedPreferences([...selectedPreferences, category]);
        } else {
          setSelectedPreferences(
            selectedPreferences.filter((x) => x !== category)
          );
        }
      }}
      sx={{
        background: selectedPreferences.includes(category)
          ? `url(${HexagonHovered})`
          : `url(${Hexagon})`,
        width: { xs: 100, md: 200 },
        height: { xs: 100, md: 200 },
        backgroundSize: "contain",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: selectedPreferences.includes(category)
          ? "scale(1.1)"
          : "none",
        "&:hover": {
          cursor: "pointer",
          transform: "scale(1.1)",
          transitionDuration: "500ms",
        },
      }}
    >
      {selectedPreferences.includes(category) ? (
        <Typography
          align="center"
          sx={{
            color: CGI_WHITE,
            fontSize: { xs: 10.5, md: 22 },
            userSelect: "none",
            width: { xs: 70, md: 140 },
          }}
        >
          {category}
        </Typography>
      ) : (
        <Typography
          align="center"
          sx={{
            background: CGI_GRADIENT_A_45DEG,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: 10.5, md: 22 },
            userSelect: "none",
            width: { xs: 70, md: 140 },
          }}
        >
          {category}
        </Typography>
      )}
    </Box>
  );
}
